var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDystopia = function SvgDystopia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.026 7H0l6.92 7.857a2.234 2.234 0 0 0 1.681.748h2.764L6.212 9.753h6.678c4.103 0 7.567 3.049 7.721 6.955.095 2.348-1.014 4.593-2.975 6.019l-3.18-3.61a2.234 2.234 0 0 0-1.68-.749h-2.764L14.955 24a7.962 7.962 0 0 1-1.929.238H3.457c-.648 0-1.263.273-1.68.746L0 27h12.869c5.765 0 10.574-4.369 10.648-9.862.073-5.525-4.567-10.061-10.367-10.131-.041 0-.082 0-.124-.002",
    fill: "#0B5E8E"
  })));
};
export default SvgDystopia;